import React from "react";
import Posts from "../components/Posts";
import Sidebar from "../components/Sidebar";

const Home = () => {
  return (
    <section className="wrapper">
      <Sidebar />
      <Posts />
    </section>
  );
};

export default Home;
